export interface SentryEnvironmentInput {
  productionBuild: boolean;
  sentryEnvironment?: string | null;
  environment?: string | null;
}

const ENVIRONMENT_MAP: Record<string, string> = {
  development: 'local',
  dev: 'dev',
  test: 'test',
  production: 'prod',
};

function present(value: string | null | undefined): string | null {
  return value ? value : null;
}

/**
 * Names the Sentry environment the same way main.ts did before this helper
 * existed. A non-empty sentryEnvironment wins. Otherwise a known app
 * environment is mapped, and any other name (preview slots included) is kept.
 */
export function resolveSentryEnvironment(input: SentryEnvironmentInput): string {
  const explicit = present(input.sentryEnvironment);
  if (explicit) {
    return explicit;
  }

  const environment = present(input.environment);
  if (environment) {
    return ENVIRONMENT_MAP[environment] || environment;
  }

  return input.productionBuild ? 'prod' : 'local';
}

/** Local developer sessions are not sent. Every other resolved name is. */
export function shouldSendSentryEvents(sentryEnvironment: string): boolean {
  return sentryEnvironment !== 'local';
}
